exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3x4K {\n    width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: center;\n        align-items: center;\n    text-align: center;\n    padding: 20px;\n}\n\n._2lLm {\n    max-height: 250px;\n    max-width: 100%;\n}\n\n._2-ja {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    padding: 0 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_3x4K",
	"image": "_2lLm",
	"actionBar": "_2-ja"
};